{
    "Accessibility Menu": "Hozzáférhetőségi menü",
    "Reset settings": "Beállítások visszaállítása",
    "Close": "Bezárás",
    "Content Adjustments": "Tartalom beállításai",
    "Adjust Font Size": "Betűméret beállítása",
    "Highlight Title": "Cím kiemelése",
    "Highlight Links": "Linkek kiemelése",
    "Readable Font": "Olvasható betűtípus",
    "Color Adjustments": "Színbeállítások",
    "Dark Contrast": "Sötét kontraszt",
    "Light Contrast": "Világos kontraszt",
    "High Contrast": "Magas kontraszt",
    "High Saturation": "Magas telítettség",
    "Low Saturation": "Alacsony telítettség",
    "Monochrome": "Monokróm",
    "Protanopia": "Protanópia",
    "Deuteranopia": "Deuteranópia",
    "Tritanopia": "Tritanópia",
    "Visual & Navigation Aids": "Vizuális és navigációs segédeszközök",
    "Additional Tools": "További eszközök",
    "Reading Guide": "Olvasási útmutató",
    "Stop Animations": "Animációk leállítása",
    "Big Cursor": "Nagy kurzor",
    "Screen Reader": "Képernyőolvasó",
    "Hide Images": "Képek elrejtése",
    "Image Tooltips": "Kép-eszköztippek",
    "Page Structure": "Oldalstruktúra",
    "Super Focus": "Szuperfókusz",
    "Magnifier": "Nagyító",
    "Increase Font Size": "Betűméret növelése",
    "Decrease Font Size": "Betűméret csökkentése",
    "Letter Spacing": "Betűtávolság",
    "Line Height": "Sor magasság",
    "Font Weight": "Betűtípus vastagsága",
    "Dyslexia Font": "Dyslexia betűtípus",
    "Language": "Nyelv",
    "Open Accessibility Menu": "Hozzáférhetőségi menü megnyitása",
    "Accessibility Profiles": "Hozzáférhetőségi profilok",
    "Seizure Safe Profile": "Epilepsziabiztos profil",
    "Stops animations and reduces color saturation.": "Leállítja az animációkat és csökkenti a színtelítettséget.",
    "Blind Profile": "Vakok profilja",
    "Activates the screen reader for auditory navigation.": "Aktiválja a képernyőolvasót hangnavigációhoz.",
    "Visually Impaired Profile": "Gyengénlátók profilja",
    "Enhances contrast and readability for low vision.": "Javítja a kontrasztot és olvashatóságot gyengénlátók számára.",
    "ADHD Friendly Profile": "ADHD-barát profil",
    "Reduces distractions for better focus.": "Csökkenti a zavaró tényezőket a jobb koncentráció érdekében.",
    "Cognitive & Learning Profile": "Kognitív és tanulási profil",
    "Helpful tools for reading and comprehension.": "Hasznos eszközök olvasáshoz és megértéshez.",
    "Motor Impaired Profile": "Mozgáskorlátozott profil",
    "Optimizes the site for keyboard-only navigation.": "Optimalizálja az oldalt a csak billentyűzetes navigációhoz.",
    "Headings": "Fejlécek",
    "Landmarks": "Tájékozódási pontok",
    "Links": "Hivatkozások",
    "Focus element": "Elem fókuszálása",
    "Visit link": "Hivatkozás megnyitása"
}
